import { Icon } from '@iconify/react';
import type { FC } from 'react';

import Text from '@/components/Text';
import type { GithubProfileRepo } from '@/services/externalCandidates';
import { dateFormatter } from '@/utils/date';

import RepositoryLanguages from './RepositoryLanguages';

type Props = GithubProfileRepo;

const Repository: FC<Props> = ({
  description,
  forks,
  htmlUrl,
  name,
  stars,
  watchers,
  programmingLanguages,
  createdAt,
  updatedAt,
}) => {
  const programmingLanguagesArray = programmingLanguages
    ? Object.entries(programmingLanguages)
    : [];

  const stats = [
    {
      icon: 'material-symbols-light:kid-star-outline',
      value: `${stars} Stars`,
    },
    { icon: 'material-symbols-light:fork-right', value: `${forks} Forks` },
    {
      icon: 'material-symbols-light:person-outline',
      value: `${watchers} Watchers`,
    },
  ];
  return (
    <div className="flex flex-col gap-2 rounded-lg bg-neutral-800 px-4 py-2">
      <div className="flex flex-col gap-1 border-b border-neutral-700 pb-1">
        <a href={htmlUrl} target="_blank" className="flex items-center gap-1">
          <Text className="font-semibold text-primary-300">{name}</Text>
          <Icon
            icon="material-symbols-light:open-in-new"
            className="text-xl text-primary-300"
          />
        </a>
        <Text
          variant="body-caption"
          title={description ?? ''}
          className="truncate text-neutral-100"
        >
          {description || 'No description'}
        </Text>
      </div>
      <div className="flex flex-col gap-1">
        {stats.map(({ icon, value }) => (
          <div key={value} className="flex items-center gap-1">
            <Icon className="text-neutral-300" icon={icon} />{' '}
            <Text variant="body-caption" className="text-neutral-300">
              {value}
            </Text>
          </div>
        ))}
      </div>
      <Text variant="body-small" className="font-semibold text-neutral-200">
        Language:
      </Text>
      <RepositoryLanguages languages={programmingLanguagesArray} />
      <div className="mt-auto flex flex-col gap-1">
        <Text variant="body-caption" className="text-neutral-300">
          Created:{' '}
          {dateFormatter({ date: createdAt, format: { dateStyle: 'short' } })}
        </Text>
        <Text variant="body-caption" className="text-neutral-300">
          Updated:{' '}
          {dateFormatter({ date: updatedAt, format: { dateStyle: 'short' } })}
        </Text>
      </div>
    </div>
  );
};

export default Repository;
